(function() {
  function initContactUsCardDrawer() {
    const trigger = document.getElementById('ContactUsCardTrigger');
    const drawer = document.getElementById('ContactUsCardDrawer');
    const overlay = document.getElementById('ContactUsCardOverlay');
    const closeBtn = document.getElementById('ContactUsCardClose');
    const form = document.getElementById('ContactUsCardContactForm');
    const mainView = document.getElementById('ContactUsCardMainView');
    const successState = document.getElementById('ContactUsCardSuccessState');
    const submitBtn = document.getElementById('ContactUsCardSubmitBtn');

    if (!trigger || !drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // AJAX form submit handler
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'SENDING...';
        }

        const formData = new FormData(form);

        fetch(form.action || '/contact#contact_form', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(function(res) {
          if (mainView) mainView.style.display = 'none';
          if (successState) successState.style.display = 'block';
        })
        .catch(function(err) {
          form.submit();
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactUsCardDrawer);
  } else {
    initContactUsCardDrawer();
  }
})();
